(ns kyber.kyber-db.external-user)

(def model
  {:ident-key
   :external-user/id

   :refs
   {:external-user/staff
    {:model :external-user
     :cardinality :many}

    :external-user/activity-director-reports
    {:model :activity-director-report
     :cardinality :many}}

   :schema
   #:external-user
   {:id {:doc "ID of the external user"}}})
